import { Button, Card } from "@120wateraudit/waterworks";
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Page from "src/components/Page";
import { SubmissionPeriodDropdown } from "src/modules/Submissions/SubmissionPeriodDropdown";
import styled from "styled-components";
import PageHeader from "src/components/PageHeader";
import Loader from "src/components/Loader";
import Exporter from "./Exporter";
import { useConfig, Flags } from "src/hooks/useConfig";
import { useTableState } from "src/hooks/useTableState";
import { useIsWrite } from "src/modules/User";
import { SubnavigationTabs } from "src/components/SubnavigationTabs/SubnavigationTabs";
import SubmissionsStatusesMetricsCard from "./SubimssionsStatusesMetricsCard";
import { SubmissionPeriodType } from "src/types/enums/SubmissionPeriodType";
import PwsSubmissionPeriodsTableVersionTwo from "src/modules/Submissions/PwsSubmissionPeriodsTableVersionTwo";
import { ExportType } from "src/types/enums/ExportRequest";

const InventoryPageVersionTwo: React.FC = () => {
  const { isWrite } = useIsWrite();
  const [submissionPeriodId, setSubmissionPeriodId] = React.useState<number>();
  const [hasStatePortalSidwisExport] = useConfig(Flags.statePortalSidwisExport);
  const [submissionPeriodManagementEnabled] = useConfig(
    Flags.SubmissionPeriodManagement
  );

  const [statePortalSubmissionsExportEnabled] = useConfig(
    Flags.statePortalSubmissionsExport
  );

  const exportOptions = useMemo(() => [
    { key: "exportAll", text: "SDWIS - All", value: ExportType.FullSDWIS },
    {
      key: "onlyMostRecent",
      text: "SDWIS - New",
      value: ExportType.MostRecentSDWIS,
    },
    ...(statePortalSubmissionsExportEnabled
      ? [
          {
            key: "exportSubmissionPeriod",
            text: "Submissions",
            value: ExportType.PWSSubmissionPeriod,
          },
        ]
      : []),
  ], [statePortalSubmissionsExportEnabled]);

  const navigate = useNavigate();

  const handleClick = (): void => {
    navigate("/accountSettings/manageSubmissionPeriods");
  };

  const tableContext = useTableState();

  return (
    <Page
      title={
        <TitleContainer>
          <PageHeader>Submissions</PageHeader>

          {submissionPeriodManagementEnabled && isWrite && (
            <Button variant="primary" onClick={handleClick}>
              Create a New Submission Period
            </Button>
          )}
        </TitleContainer>
      }
    >
      <SubnavigationTabs
        subnavigationTabs={[
          { label: "Inventory", to: "/submissions" },
          {
            label: "Customer Notice Certifications",
            to: "/submissions/customerNoticeCertification",
          },
        ]}
      />

      <TopSectionWrapper>
        <SubmissionsStatusesMetricsCard
          submissionPeriodId={submissionPeriodId}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "-webkit-fill-available",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
        >
          <SubmissionPeriodDropdown
            setSubmissionPeriodId={setSubmissionPeriodId}
            defaultFilters={{
              submissionType: SubmissionPeriodType.inventory,
            }}
          />
          <div style={{ marginBottom: "12px" }}>
            {hasStatePortalSidwisExport && (
                <Exporter
                  submissionPeriodId={submissionPeriodId ?? 0}
                  submissionPeriodType={SubmissionPeriodType.inventory}
                  params={tableContext.params}
                  options={exportOptions}
                />
            )}
          </div>
        </div>
      </TopSectionWrapper>
      {!submissionPeriodId ? (
        <Loader />
      ) : (
        <Card>
          <PwsSubmissionPeriodsTableVersionTwo
            submissionPeriodId={submissionPeriodId}
            tableContext={tableContext}
          />
        </Card>
      )}
    </Page>
  );
};

const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: 16px;
`;

const TopSectionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: end;
  padding-top: 3rem;
  padding-bottom: 2rem;
`;

export default InventoryPageVersionTwo;
